import { S_AUTH_TOKEN, S_LANG, S_STAFF_INFO, /*S_USER,*/ webStorage } from "./webStorage";
import getSiteInfo from "./getSiteInfo";
import { restoreData } from "../redux/restoreData";

const getApiHeader = async () => {
  const token = webStorage.get(S_AUTH_TOKEN);
  // const user = webStorage.get(S_USER);
  const staffInfo = restoreData(S_STAFF_INFO, null);
  // const userAccount = token?.userAccount || user?.userAccount;
  const lang = webStorage.get(S_LANG) || "en";
  const siteInfo = await getSiteInfo();
  const channel = staffInfo ? "STORE" : "WEBSITE";
  const language = siteInfo.language;
  const organization = siteInfo.organization;
  const headers = {
    lang: lang,
    channel: channel
  };
  if (language) {
    Object.assign(headers, {
      language
    });
  }
  if (organization) {
    Object.assign(headers, {
      organization
    });
  }
  if (token) {
    Object.assign(headers, {
      userAccount: token.userAccount,
      accessToken: token.accessToken
    });
  }
  return headers;
};
export default getApiHeader;
